export default __webpack_public_path__ + "static/media/icon_shield.9a687475.svg";